import React, { useState } from 'react'
import { IconButton, Tooltip, Typography } from '@material-ui/core'
import { Eye as EyeIcon } from 'react-feather'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'

import DataLifeCycleProvider from 'providers/DataLifeCycleProvider'
import AssetInventoryProvider from 'providers/AssetInventoryProvider'

import useStyles from './styles'
import { DataLifeCycleModal } from 'views/DataProcesses/components/DataLifeCycleModal'

const DataLifeCycleTable = ({ lifeCycles = [], dataProcess }) => {
  const [lifeCycle, setLifeCycle] = useState()
  const [open, setOpen] = useState(false)

  const classes = useStyles()

  const handleOpenModal = (lifeCycle) => {
    setLifeCycle(lifeCycle)
    setOpen(true)
  }

  const handleCloseModal = () => {
    setLifeCycle()
    setOpen(false)
  }

  return (
    <PerfectScrollbar>
      <Table
        emptyMessage="NENHUM SALVAGUARDA E CICLO DE VIDA FOI ENCONTRADO"
        noWrap
      >
        <TableHead>
          <TableRow>
            <TableCell width="15%">Ambiente de alocação</TableCell>
            <TableCell width="20%">Categoria de ativos</TableCell>
            <TableCell width="20%">Ativos</TableCell>
            <TableCell width="15%">Tempo de armazenamento</TableCell>
            <TableCell width="30%">Como os dados são dispostos</TableCell>
            <TableCell width="5%" align="center">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {lifeCycles.map((dataLifeCycle) => (
            <TableRow key={dataLifeCycle.id}>
              <TableCell>
                <Tooltip title={dataLifeCycle?.internalAllocationMode?.name}>
                  <Typography className={classes.ellipsisTable}>
                    {dataLifeCycle?.internalAllocationMode?.name}
                  </Typography>
                </Tooltip>
              </TableCell>
              <TableCell>
                <Tooltip
                  title={
                    dataLifeCycle?.assetInventory?.assetInventoryCategory
                      ?.name ||
                    dataLifeCycle?.assetInventoryCategory?.name ||
                    'Não informado'
                  }
                >
                  <Typography className={classes.ellipsisTable}>
                    {dataLifeCycle?.assetInventory?.assetInventoryCategory
                      ?.name ||
                      dataLifeCycle?.assetInventoryCategory?.name ||
                      'Não informado'}
                  </Typography>
                </Tooltip>
              </TableCell>
              <TableCell>
                <Tooltip
                  title={
                    dataLifeCycle?.assetInventory?.name || 'Não classificado'
                  }
                >
                  <Typography className={classes.ellipsisTable}>
                    {dataLifeCycle?.assetInventory?.name || 'Não classificado'}
                  </Typography>
                </Tooltip>
              </TableCell>
              <TableCell>
                <Tooltip
                  title={helpers.dataProcess.storageModeType(
                    dataLifeCycle?.storageType,
                    dataLifeCycle?.value,
                    dataLifeCycle?.volumetry,
                    !!dataLifeCycle?.value && !!dataLifeCycle?.volumetry,
                  )}
                >
                  <Typography className={classes.ellipsisTable}>
                    {helpers.dataProcess.storageModeType(
                      dataLifeCycle?.storageType,
                      dataLifeCycle?.value,
                      dataLifeCycle?.volumetry,
                      !!dataLifeCycle?.value && !!dataLifeCycle?.volumetry,
                    )}
                  </Typography>
                </Tooltip>
              </TableCell>
              <TableCell>
                <Tooltip title={helpers.dataProcess.discardMode(dataLifeCycle)}>
                  <Typography className={classes.ellipsisTable}>
                    {helpers.dataProcess.discardMode(dataLifeCycle)}
                  </Typography>
                </Tooltip>
              </TableCell>

              <TableCell align="right" size="small">
                <IconButton onClick={() => handleOpenModal(dataLifeCycle)}>
                  <EyeIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <AssetInventoryProvider>
        <DataLifeCycleProvider
          dataLifeCycles={lifeCycles}
          dataProcessId={dataProcess?.id}
        >
          {open && (
            <DataLifeCycleModal
              dataProcess={dataProcess}
              dataProcessId={dataProcess?.id}
              classes={classes}
              open={open}
              setOpen={handleCloseModal}
              dataLifeCycle={lifeCycle}
              mode="show"
            />
          )}
        </DataLifeCycleProvider>
      </AssetInventoryProvider>
    </PerfectScrollbar>
  )
}

export default DataLifeCycleTable
